<template>
  <v-container>
    <h1 class="text-h4 my-12">{{ header }}</h1>

    <div v-html="message"></div>

    <v-btn
      large
      color="primary"
      outlined
      class="my-12"
      v-if="website"
      :href="website"
    >
      <v-icon left>mdi-web</v-icon>
      {{
        $vuetify.lang.t(
          "$vuetify.inspectech.order.confirm.website",
          organization.name
        )
      }}
    </v-btn>
  </v-container>
</template>

<script>
import { marked } from "marked";
import DOMPurify from "dompurify";

export default {
  name: "Success",
  props: {
    organization: {
      type: Object,
      required: true,
    },
    result: {
      type: Object,
    },
  },
  data: () => ({}),
  computed: {
    header() {
      return (
        this.$store.getters.setting("order.completed.header") ||
        this.$vuetify.lang.t("$vuetify.inspectech.order.confirm.header")
      );
    },
    message() {
      const text =
        this.$store.getters.setting("order.completed.text") ||
        this.$vuetify.lang.t("$vuetify.inspectech.order.confirm.message");
      return text
        ? DOMPurify.sanitize(
            marked(text, {
              mangle: false,
              headerIds: false,
              breaks: true,
              gfm: true,
            }),
            { USE_PROFILES: { html: true } }
          )
        : "";
    },
    website() {
      return this.$store.getters.website;
    },
  },
  methods: {},
};
</script>
